import { isNil } from 'lodash'

import { usePostReported } from './PostItem/PostItem.hooks'
import { Post, Group } from 'lib/_types'
import { useIsGroupAdmin } from 'components/Post/PostItem/PostItem.hooks'

import PostText from './PostText'
import PostCall from './PostCall'
import PostImage from './PostImage'
import PostYoutube from './PostYoutube'
import PostSurvey from './PostSurvey'
import PostShareableGroup from './PostShareableGroup'
import PostShareablePost from './PostShareablePost'
import PostVideo from './PostVideo'
import PostThread from './PostThread'
import MetaDataPreviewCard from '../MetaDataPreviewCard'
import PostEdited from './PostEdited'

// https://miro.com/app/board/uXjVPRP3_pU=/?moveToWidget=3458764534944598184&cot=14

const PostContent = ({
  post,
  isShared,
  forceMultiplePostImage,
  group,
  noText,
  onVote,
  postLink,
  isEdit,
  highlight,
}: {
  post: Post
  group?: Partial<{ data: Group }>
  isShared?: boolean
  forceMultiplePostImage?: boolean
  noText?: boolean
  onVote?: Function
  postLink?: string
  isEdit?: boolean
  highlight?: string
}) => {
  const isGroupPost = !isNil(post?.group_id)
  const isGroupAdmin = useIsGroupAdmin({ group })

  const postReported = usePostReported({
    post,
    mayShowInappropriateContent:
      !isGroupPost || isGroupAdmin || !group?.data?.hide_reported_posts,
  })

  if (postReported) return postReported

  return (
    <>
      {!noText && (
        <PostText
          post={post}
          isShared={isShared}
          postLink={postLink}
          highlight={highlight}
        />
      )}

      <PostCall post={post} disabled={isEdit} />

      <PostImage
        post={post}
        isShared={isShared}
        forceMultiple={forceMultiplePostImage}
      />

      <PostYoutube post={post} />
      <PostVideo post={post} />
      <PostSurvey post={post} onVote={onVote} />
      <PostShareableGroup post={post} disabled={isEdit} />

      {post?.shareable?.post && (
        <PostShareablePost post={post?.shareable?.post} disabled={isEdit} />
      )}

      <PostThread post={post} />

      {post?.shared_url && post?.post_type !== 'youtube' && (
        <MetaDataPreviewCard
          description={post?.shared_url?.description}
          url={post?.shared_url?.url}
          title={post?.shared_url?.title}
          imageUrl={post?.shared_url?.image_url}
          onClose={null}
        />
      )}

      {!noText && <PostEdited post={post} />}
    </>
  )
}

export default PostContent
